/* istanbul ignore file */

import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { CompactProductFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { CompactProductFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import { taxHintDataMock } from '../TaxHint/mockdata';
import { priceDataMock } from '../Price/mockdata';

export const compactProductDataMock: CompactProductFragmentFragment = {
  name: 'Nike Sportswear Sneaker »Air Max Ltd 3«',
  price: priceDataMock,
  media: [
    {
      type: 'CLIPLISTER',
      url: 'https://bilder.baur.de/i/empiriecom/57e9dd4f9aa4287fd801cc53b0ef2d5d',
    },
    {
      type: 'IMAGE',
      url: 'https://bilder.baur.de/i/empiriecom/57e9dd4f9aa4287fd801cc53b0ef2d5d',
    },
  ],
  delivery: taxHintDataMock,
};

export function getCompactProductFragmentedData(data?: CompactProductFragmentFragment) {
  return makeFragmentData(data || compactProductDataMock, CompactProductFragmentFragmentDoc);
}
